
export default {
  name: 'icon-status-arrived',
};
